import styled from "styled-components";

export const Style = styled.div`
  flex: 1;
  display: flex;

  .legend-cont {
    display: flex;
    gap: 25px;

    .item {
      display: flex;
      gap: 8px;
      cursor: pointer;
      transition: .4s opacity;

      &.disabled {
        opacity: 0.3;
      }

      label {
        color: #595959;
        font-size: 12px;
        font-weight: 500;
        margin-bottom: 0px;
        cursor: pointer;
      }

      .legend {
        width: 8px;
        height: 8px;
        border-radius: 100%;
      }
    }
  }
`;
